export interface IUiContextState {
  sendEmailFormVisible: boolean;
  emailSuccessVisible?: boolean;
  specifiedItemTypeId?: number;
  showPromoCodeForm: boolean;
  showPromoCodeSuccess?: boolean;
  showPromoCodeFailure?: boolean;
  qqcAlertMessage?: string;
  travellerAgeSelection?: string;
}

export const defaultUiContextState: IUiContextState = {
  sendEmailFormVisible: false,
  showPromoCodeForm: false,
};
